/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneSecondNativeArticle from 'base/components/standalone/SecondNativeArticle';

export const DynamicStandaloneSecondNativeArticle = StandaloneSecondNativeArticle;
export type DynamicStandaloneSecondNativeArticleProps = PropsFromComponent<typeof StandaloneSecondNativeArticle>;

export const DynamicStandaloneSecondNativeArticleWith = (extras: DynamicStandaloneExtras): typeof StandaloneSecondNativeArticle => {
    return function DynamicStandaloneSecondNativeArticle(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'SecondNativeArticle');
        return <StandaloneSecondNativeArticle {...mergeProps({ options: { theme } }, props)} />;
    }
}